import React from "react";
import styles from "./OfferCard.module.sass";

import Card from "../ui/Card/Card";
import OfferType from "../OfferType/OfferType";

import currency from "../../utils/currency";

import Button from "../ui/Button/Button";
import { simulationType } from "../../containers/Products/Products";
import KeyValueItem from "../ui/KeyValueItem/KeyValueItem";
import gaTags from "./../../utils/ga-tags";
import useChatUrl from "../../hooks/useChatUrl";

const NOT_SPECIFIED = "Não Especificada";

const getProduct = (productType) =>
  parseInt(productType) === 1 ? "Imóvel" : "Veículo";

const getGaTypeName = (product, hidden, group) => {
  return hidden
    ? ""
    : `${gaTags.type}&${product}&-&${currency.numberToCurrency(
        group.dados.valorParcela
      )}&-&${group.dados.plano.prazo.restante + `meses`}-`;
};

const offerCard = (props) => {
  const { callChat } = useChatUrl();
  const product = getProduct(props.productType);
  const gaTypeName = getGaTypeName(product, props.hidden, props.group);

  return props.hidden ? (
    <div className={styles.HiddenOffer} />
  ) : (
    <li className={styles.OfferCard}>
      <Card showHeader={true}>
        {!props.isDesktop ? (
          <>
            <div className={styles.OfferTypeWrapper}>
              <OfferType
                showIcon={false}
                type={props.productType}
                groupLabel="Grupo"
                groupNumber={props.group.identificacao.codigoNegocio}
              />

              <div className={styles.groupStatus}>
                {groupStatus[props.group.dados.situacao]}
              </div>
            </div>
            {props.group.desconto && (
              <div className={styles.discountBanner}>
                <p className={styles.bannerTitle}>
                  20<span>%</span>
                </p>
                <p className={styles.bannerText}>
                  de desconto na taxa de administração
                </p>
              </div>
            )}
            <KeyValueItem
              Key={"Parcelas a partir de"}
              Value={
                "R$ " +
                currency.numberToCurrency(props.group.dados.valorParcela)
              }
            />
            <KeyValueItem
              Key={"Período"}
              Value={props.group.dados.plano.prazo.restante + " meses"}
            />
            <KeyValueItem
              Key={"Valor do crédito"}
              Value={
                "R$ " +
                currency.numberToCurrency(props.group.dados.valorCredito)
              }
            />
          </>
        ) : (
          <React.Fragment>
            <div className={styles.OfferTypeWrapper}>
              <OfferType
                showIcon={true}
                type={props.productType}
                groupLabel="Grupo"
                groupNumber={props.group.identificacao.codigoNegocio}
              />
              <div className={styles.groupStatus}>
                {groupStatus[props.group.dados.situacao]}
              </div>
            </div>
            <div className={styles.divider} />
            {props.simulationType === simulationType.PARCELA ? (
              <div>
                {props.group.desconto && (
                  <div className={styles.discountBanner}>
                    <p className={styles.bannerTitle}>
                      20<span>%</span>
                    </p>
                    <p className={styles.bannerText}>
                      de desconto na taxa de administração
                    </p>
                  </div>
                )}
                <div>
                  <div className={styles.title}>Parcelas a partir de:</div>
                  <div className={styles.value}>
                    {" "}
                    {"R$" +
                      currency.numberToCurrency(
                        props.group.dados.valorParcela
                      )}{" "}
                  </div>
                  <div className={styles.subtitle}>
                    em {props.group.dados.plano.prazo.restante + " meses"}
                  </div>
                  <div className={styles.divider} />
                  <div className={styles.complement + " " + styles.bold}>
                    Valor do crédito{" "}
                    {"R$ " +
                      currency.numberToCurrency(props.group.dados.valorCredito)}
                  </div>
                </div>
              </div>
            ) : (
              <div>
                {props.group.desconto && (
                  <div className={styles.discountBanner}>
                    <p className={styles.bannerTitle}>
                      20<span>%</span>
                    </p>
                    <p className={styles.bannerText}>
                      de desconto na taxa de administração
                    </p>
                  </div>
                )}
                <div className={styles.title}>Valor do crédito:</div>
                <div className={styles.value}>
                  {" "}
                  {"R$ " +
                    currency.numberToCurrency(
                      props.group.dados.valorCredito
                    )}{" "}
                </div>
                <div className={styles.divider} />
                <div className={styles.complement}>
                  Parcelas a partir de{" "}
                  <span className={styles.bold}>
                    {" "}
                    {"R$ " +
                      currency.numberToCurrency(props.group.dados.valorParcela)}
                  </span>{" "}
                  em{" "}
                  <span className={styles.bold}>
                    {props.group.dados.plano.prazo.restante + " meses"}
                  </span>
                </div>
              </div>
            )}
            <div className={styles.divider} />
          </React.Fragment>
        )}
        <Button
          selected
          onClick={(event) => {
            props.offerChosen({ ...props });
            window.dataLayer.push({
              event: "datalayereventos",
              gacategory:
                event.target.getAttribute("data-gacategory") || NOT_SPECIFIED,
              gatype: event.target.getAttribute("data-gatype") || NOT_SPECIFIED,
              gafunc: event.target.getAttribute("data-gafunc") || NOT_SPECIFIED,
            });
            props.onClick && props.onClick(event);
          }}
          data-gacategory={gaTags.categoryDefault}
          data-gatype={`${gaTypeName}CardComprar`}
          data-gafunc={`${gaTypeName}BTN.Verdetalhe`}
        >
          Ver detalhes
        </Button>
      </Card>
      <div className={styles.cardFooter}>
        {!props.ibc && !props.group.desconto && process.env.REACT_APP_DISABLE_CHAT !== 'true' && (
          <>
            Falar no
            <span className={styles.link} onClick={() => callChat()}>
              Chat
            </span>
          </>
        )}
        ou procurar uma
        <a
          className={styles.link}
          href="http://www.caixa.gov.br/atendimento/Paginas/encontre-a-caixa.aspx"
          rel="noopener noreferrer"
          target="_blank"
        >
          agência Caixa
        </a>
        .
      </div>
    </li>
  );
};
export const groupStatus = {
  A: "em andamento",
  F: "em formação",
};

export default offerCard;
